import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CrossThin = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M4.31672 27.7079C4.70627 28.0975 5.33786 28.0975 5.72742 27.7079L16.0123 17.4231L26.2971 27.7079C26.6866 28.0975 27.3182 28.0975 27.7078 27.7079C28.0973 27.3184 28.0973 26.6868 27.7078 26.2972L17.423 16.0124L27.7078 5.72753C28.0974 5.33797 28.0974 4.70638 27.7078 4.31682C27.3182 3.92727 26.6867 3.92727 26.2971 4.31682L16.0123 14.6017L5.72741 4.31683C5.33785 3.92727 4.70626 3.92727 4.3167 4.31683C3.92715 4.70638 3.92715 5.33797 4.3167 5.72753L14.6015 16.0124L4.31672 26.2972C3.92716 26.6868 3.92716 27.3184 4.31672 27.7079Z" />
	</svg>
);

export default CrossThin;
